import React from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';

import { getColorFromScheme } from '../../helpers/utils';

// Button color schemes
const schemes = {
  success: {
    bg: 'bg-emerald-600 hover:bg-emerald-500',
    outline: 'focus-visible:outline-emerald-600'
  },
  warning: {
    bg: 'bg-orange-600 hover:bg-orange-500',
    outline: 'focus-visible:outline-orange-600'
  },
  error: {
    bg: 'bg-red-600 hover:bg-red-500',
    outline: 'focus-visible:outline-red-600'
  },
  neutral: {
    bg: 'bg-gray-600 hover:bg-gray-500',
    outline: 'focus-visible:outline-gray-600'
  },
};

export function SecondaryCTA({ type, children, icon, ...rest }) {
  const color = getColorFromScheme(type);

  return (
    <a
      className={classNames(
      `select-none flex items-center rounded bg-white px-2 py-1 text-sm font-medium shadow-sm ring-1 ring-inset ml-2 cursor-pointer text-${color}-900 ring-${color}-300 hover:bg-${color}-50 active:bg-${color}-200`,
        rest.className || {}
      )}
      {...omit(rest, ['className'])}
    >{icon && <div className="mr-1 flex items-center">{icon}</div>}{children}</a>
  );
}

export function PrimaryCTA({ type, children, ...rest }) {
  const scheme = schemes[type] || schemes.neutral;

  return (
    <a className={classNames(
      `select-none text-center inline-block mt-4 rounded px-4 py-2 text-sm font-normal text-white shadow-sm cursor-pointer ${scheme.bg}`,
        `focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${scheme.outline}`,
        rest.className || {}
      )}
      {...omit(rest, ['className'])}
    >{children}</a>
  );
}
